import React, { Dispatch, FC, FormEvent, Fragment, SetStateAction, useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  TextField,
} from '@mui/material';

import styles from './CreatePortfolioDialog.module.scss';
import { PortfolioService } from 'pages/PortfoliosPage/PortfolioService';
import { AlertConfigModel } from 'dialogs/AlertDialog/AlertConfigModel';
import AlertDialog from 'dialogs/AlertDialog/AlertDialog';

interface CreatePortfolioDialogProps {
  setOpen: Dispatch<SetStateAction<boolean>>;
  onPortfolioCreation: () => void;
}

const CreatePortfolioDialog: FC<CreatePortfolioDialogProps> = (props) => {

  const [currentAlert, setCurrentAlert] = useState<AlertConfigModel | null>(null);
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState<boolean>(false);
  const [name, setName] = useState<string>('')
  const [description, setDescription] = useState<string>('')

  const clearStates = (): void => {
    setName('');
    setDescription('');
  };

  const closeHandler = (event?: Object, reason?: any): void => {
    if (reason && reason === 'backdropClick') return;

    clearStates();
    props.setOpen(false);
  };

  const createPortfolioHandler = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault(); // Prevent the default form submission behavior, which sends a request

    try {
      const creationResult = await PortfolioService.createPortfolio(name, description);

      if (!creationResult) {
        throw new Error('Error creating portfolio');
      }

      props.onPortfolioCreation();
      closeHandler();
    } catch (error) {
      console.error('Failed at creating a new portfolio:', error);
      const alertConfig: AlertConfigModel = {title: 'Error', message: 'Failed at creating portfolio. Please try again, and contact support if the issue persists.'};
      setCurrentAlert(alertConfig);
      setIsAlertDialogOpen(true);
    }
  }

  const creationForm: JSX.Element = (
    <Fragment>
      <form onSubmit={createPortfolioHandler}>
        <FormControl className={styles.portfolioCreationFormControl}>
          <FormLabel required>Name</FormLabel>
          <TextField
            // label="Name"
            placeholder="Name of portfolio"
            className={styles.formTextField}
            autoFocus
            required
            size="small"
            value={name}
            onChange={event => setName(event.target.value)}
          ></TextField>
        </FormControl>

        <FormControl className={styles.portfolioCreationFormControl}>
          <FormLabel required>Description</FormLabel>
          <TextField
            // label="Description"
            placeholder="Portfolio description"
            className={styles.formTextField}
            required
            size="small"
            value={description}
            onChange={event => setDescription(event.target.value)}
          ></TextField>
        </FormControl>

        <DialogActions className={styles.formButtons}>
          <Button
            onClick={closeHandler}
            color="error"
            variant="outlined"
          >
            Cancel
          </Button>

          <Button
            type="submit"
            color={'primary'}
            variant="contained"
          >
            Create
          </Button>
        </DialogActions>
      </form>
    </Fragment>
  );

  return (
    <Fragment>
      <Dialog
        className={styles.CreatePortfolioDialog}
        data-testid="CreatePortfolioDialog"
        open={true}
        onClose={closeHandler}
        fullWidth
      >
        <DialogTitle>Create Portfolio</DialogTitle>
        <DialogContent dividers={true}>
          {creationForm}
        </DialogContent>
      </Dialog>

      {isAlertDialogOpen && currentAlert &&
        <AlertDialog
          onClose={() => {
            setIsAlertDialogOpen(false);
            setCurrentAlert(null);
          }}
          title={currentAlert.title}
          message={currentAlert.message}
        ></AlertDialog>
      }
    </Fragment>
  );
}

export default CreatePortfolioDialog;
